import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const homeData = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  query HomeData($locale: SiteLocale) {
    home(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      hero {
        titolo
        testo
        immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        cards {
          titolo
          testo
          id
          coloreCard {
            hex
          }
          cta {
            testo
            link
            evento
            file {
              url
            }
          }
        }
        videoCover
        videoFullScreen
      }
      intro {
        cards {
          id
          titolo
          testo
          sottotitolo
          cta {
            testo
            link
          }
        }
      }
      sezioneServizi {
        titolo
        testo
        id
        immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
      }
      carosello {
        slide {
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
      sezioneTitoloTesto {
        titolo
        testo
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
      sezioneImmagineTesto1 {
        titolo
        immagineADestra
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        testo
        landscape: immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        portrait: immagine {
          responsiveImage(
            imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
          ) {
            ...ResponsiveImageFragment
          }
        }
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      sezioneImmagineTesto2 {
        titolo
        immagineADestra
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        testo
        landscape: immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        portrait: immagine {
          responsiveImage(
            imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
          ) {
            ...ResponsiveImageFragment
          }
        }
        cta {
          testo
          link
          file {
            url
          }
        }
      }
    }
    allNotiziaPages(locale: $locale) {
      titolo
      slug
      _allSlugLocales {
        value
        locale
      }
      landscape: cover {
        responsiveImage(imgixParams: { fm: webp, q: "50" }) {
          ...ResponsiveImageFragment
        }
      }
      portrait: cover {
        responsiveImage(
          imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
  }
`
